var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMp4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 10.5V15.5C22 20.5 20 22.5 15 22.5H9C4 22.5 2 20.5 2 15.5V9.5C2 4.5 4 2.5 9 2.5H14",
    fill: "#008000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 10.5H18C15 10.5 14 9.5 14 6.5V2.5L22 10.5Z",
    fill: "#33C633"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9699 12.33V16.5H10.2859V13.644L9.01393 16.5H8.53993L7.26193 13.644V16.5H6.57793V12.33H7.31593L8.77993 15.6L10.2379 12.33H10.9699ZM14.7849 13.572C14.7849 13.784 14.7349 13.984 14.6349 14.172C14.5349 14.36 14.3749 14.514 14.1549 14.634C13.9349 14.75 13.6529 14.808 13.3089 14.808H12.5529V16.5H11.8689V12.33H13.3089C13.6289 12.33 13.8989 12.386 14.1189 12.498C14.3429 12.606 14.5089 12.754 14.6169 12.942C14.7289 13.13 14.7849 13.34 14.7849 13.572ZM13.3089 14.25C13.5689 14.25 13.7629 14.192 13.8909 14.076C14.0189 13.956 14.0829 13.788 14.0829 13.572C14.0829 13.116 13.8249 12.888 13.3089 12.888H12.5529V14.25H13.3089ZM15.2633 15.588V15.072L17.2793 12.18H18.1073V14.994H18.6653V15.588H18.1073V16.5H17.4353V15.588H15.2633ZM17.4653 12.876L16.0493 14.994H17.4653V12.876Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMp4);
export default __webpack_public_path__ + "static/media/mp4.4265922508a0adb4aec2b257364ed004.svg";
export { ForwardRef as ReactComponent };